<template>

</template>

<script>
    export default {
        name: 'index'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/goods/index.vue